export default (params): string =>
  Object.keys(params)
    /* eslint-disable-next-line no-undefined */
    .filter((k) => params[k] !== undefined)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
